import { render, staticRenderFns } from "./serviceProviderResources.vue?vue&type=template&id=79888cb9&scoped=true&"
import script from "./serviceProviderResources.vue?vue&type=script&lang=js&"
export * from "./serviceProviderResources.vue?vue&type=script&lang=js&"
import style0 from "./serviceProviderResources.vue?vue&type=style&index=0&id=79888cb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79888cb9",
  null
  
)

export default component.exports